import { get, values } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getOnHoldReservations = get(
  'inventory.components.onHoldReservations'
);

export const getAll = createSelector(getOnHoldReservations, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getOrder = createSelector(getOnHoldReservations, get('order'));

export const getIsFetching = createSelector(
  getOnHoldReservations,
  get('fetching')
);

export const getIsFetched = createSelector(
  getOnHoldReservations,
  get('fetched')
);

export const getIsSaving = createSelector(getOnHoldReservations, get('saving'));

export const getIsSaved = createSelector(getOnHoldReservations, get('saved'));
